import React, { Fragment } from "react";
import { Button } from "react-bootstrap";
import error from "../../../../assets/errorIcon.svg";
import checked1 from "../../../../assets/checked1.png";
import "./modal.scss";

const DeleteModal = ({ okayClickHandler, title, subtitle, procedure }) => {
  function ReplaceConsultationType(messaage){
    if(messaage.includes("0")){
      return (messaage.replace("consultation type 0",procedure))
    }
    else if(messaage.includes("1")){
      return (messaage.replace("consultation type 1",procedure))
    }
    else if(messaage.includes("5")){
      return (messaage.replace("consultation type 5",procedure))
    }
    else if(messaage.includes("6")){
      return (messaage.replace("consultation type 6",procedure))
    }
    else{
      return messaage;
    }
  }

  return (
    <div className="myschedule-modal">
      <div className="text-center align-items-center">
       { subtitle.includes("We cannot delete")?<img
          src={error}
          alt="error"
          style={{ width: "60px", height: "60px" }}
        />:
         <img
          src={checked1}
          alt="error"
          style={{ width: "60px", height: "60px" }}
        />}
        <p className="font-weight-bold my-1 modal-heading">
            {/* {title} */}
            { subtitle.includes("We cannot delete")?"Error":"Time Slots deleted successfully"}
            </p>
        <p className="mt-2 mb-3 modal-paragraph">{ReplaceConsultationType(subtitle)}</p>
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <Button
          className="border-0 rounded-pill "
          style={{
            backgroundColor: "#17BAE0",
            color: "#fff",
            width: "140px",
            height: "44px",
          }}
          onClick={okayClickHandler}
        >
          Okay
        </Button>
      </div>
    </div>
  );
};

export default DeleteModal;
